export * from "./local-storage-keys";
export * from "./twap";

// wait time for blockchain transactions to be processed
// TODO: find a way to get this from our current latency estimate
export const TXN_WAIT_TIME_MS = 2000;

// time to wait for WS data before giving up and unsubscribing
export const WS_WAIT_TIME_MS = 5000;

export const MAX_NUMBER_INPUT_LENGTH = 30; // Maximum length for numeric inputs

export const AVAILABLE_BALANCE_MAX_PERCENTAGE = 0.995; // 0.5% reduction for available balance

export const SUBACCOUNTS_REFETCH_INTERVAL_MS = 1_000;
export const SUBACCOUNTS_CUTOFF_REFETCH_MS = 10_000;
export const ACCOUNT_RECONNECT_TIMEOUT_MS = 5_000;
export const ACCOUNT_RECONNECT_DELAY_MS = 500;

// Basis-point denominator: 10_000 bps = 100%. Use to translate a `*_bps`
// integer into a fraction, e.g. `(BPS_DENOMINATOR - haircut_bps) / BPS_DENOMINATOR`.
export const BPS_DENOMINATOR = 10_000;

export const DEFAULT_SHARE_PRICE = 1; // 1 USD

export const KEYLESS_ACCOUNT_EXPIRED_ERROR_KEY = "KEYLESS_ACCOUNT_EXPIRED_ERROR";

// TODO: Remove once we fix the security issues around max slippage
export const MAX_SLIPPAGE_ALLOWED = 10; // 10%
